module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak rowerowy żółty.svg?c70f71c5";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak rowerowy żółty.svg
// module id = 2035
// module chunks = 0